// extracted by mini-css-extract-plugin
export default {"wrap":"uG-z","subtitle":"vG-z","contentWrap":"wG-z","imgWrap":"xG-z","heading":"yG-z","copy":"zG-z"};